//
//
//
//
//
//
//
//

export default {
  name: 'App'
};